import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import requiredIf from "react-required-if";

import { List } from "../List";

import styles from "./TariffTile.scss";

const TariffTileListItem = forwardRef(
  ({ children, isBold, ...restProps }, ref) => {
    return (
      <List.Item ref={ref}>
        <List.Text
          customClass={cx({ [styles.listTextBold]: isBold })}
          {...restProps}
        >
          {children}
        </List.Text>
      </List.Item>
    );
  }
);

TariffTileListItem.displayName = "TariffTile.ListItem";

TariffTileListItem.propTypes = {
  children: requiredIf(
    PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf()]),
    (props) => !props.placeholder
  ),
  isBold: PropTypes.bool,
};

TariffTileListItem.defaultProps = {
  children: undefined,
  isBold: false,
};

export default TariffTileListItem;
